
import { Header } from "@/components/layout/Header";
import { JournalEntryForm } from "@/components/journal/JournalEntryForm";
import { JournalEntryList } from "@/components/journal/JournalEntryList";
import { JournalHeader } from "@/components/journal/JournalHeader";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Journal = () => {
  const [showForm, setShowForm] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate("/dashboard")}
          className="mb-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </Button>

        <div className="space-y-6">
          <JournalHeader 
            showForm={showForm} 
            onToggleForm={() => setShowForm(!showForm)} 
          />

          {showForm && (
            <div className="mb-8">
              <JournalEntryForm onSuccess={() => setShowForm(false)} />
            </div>
          )}

          <JournalEntryList />
        </div>
      </main>
    </div>
  );
};

export default Journal;
